import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthComponent } from "./auth.component";
import { LandingComponent } from "./landing/landing.component";
import { LoginComponent } from "./login/login.component";
import { SignupComponent } from "./signup/signup.component";
import { ForgetPasswordComponent } from "./forget-password/forget-password.component";
export const routes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
    children: [
      {
        path: "landing",
        component: LandingComponent,
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "signup",
        component: SignupComponent,
      },
      {
        path: "forget-password",
        component: ForgetPasswordComponent,
      },
    ],
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
